import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { id, reviews, fetchReviewsError } = props;

  return (
    <div id={id} className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
      </Heading>
      {fetchReviewsError ? (
        <p className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </p>
      ) : null}
      <Reviews  reviews={reviews} />
    </div>
  );
};

export default SectionReviews;
